import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IAskForQuestions } from '../models/askfor.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Function to get Ask For questions from api
 * 
 * @param {string} customerId the customer's id
 * @param {string} cardGroupId the partner's idi
 */
const GetAskForQuestions = async (customerId?: string, cardGroupId?: string): Promise<IAskForQuestions> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/card-group/ask-for-questions',  {
      params: {
        'wpId': userId,
        'customerId': customerId,
        'cardGroupId': cardGroupId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting Ask For questions');
    throw(error);
  }
}

export default GetAskForQuestions;